

const AdminPanel: React.FC =()=>{
    return <div></div>
}

export default AdminPanel;